import React from 'react';

export const MapIcon = (props) => {
  const { className = '', disabled = false, onClick, style = {}, fillColor = '#005D98' } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <g clip-path="url(#clip0_929_6975)">
        <path
          d="M12.0089 3.67989C14.981 3.67989 17.3942 6.21839 17.3942 9.34484C17.3942 10.7074 16.8707 11.9113 16.1698 12.9473C15.0165 14.6365 12.0089 20.0215 12.0089 20.0215C12.0089 20.0215 8.99239 14.6365 7.8479 12.9473C7.14702 11.9207 6.62357 10.7168 6.62357 9.34484C6.6147 6.21839 9.02788 3.67989 12.0089 3.67989ZM12.0089 12.126C13.7212 12.126 15.1052 10.6888 15.1052 8.91554C15.1052 7.14232 13.7212 5.70509 12.0089 5.70509C10.2966 5.70509 8.91254 7.14232 8.91254 8.91554C8.91254 10.6888 10.2966 12.126 12.0089 12.126ZM12.0089 2C8.14068 2 5 5.30378 5 9.37284C5 10.9314 5.51457 12.4806 6.53485 13.9739C7.69708 15.6818 10.82 21.2534 10.8466 21.3094C11.0862 21.7387 11.5209 22 12 22C12.4791 22 12.9138 21.7387 13.1533 21.3094C13.1888 21.2534 16.3029 15.6818 17.4651 13.9739C18.4854 12.4713 19 10.9221 19 9.37284C19.0089 5.30378 15.8682 2 12.0089 2ZM12.0089 10.7168C11.0418 10.7168 10.2522 9.90481 10.2522 8.90621C10.2522 7.90761 11.0418 7.09566 12.0089 7.09566C12.9759 7.09566 13.7655 7.90761 13.7655 8.90621C13.7655 9.90481 12.9759 10.7168 12.0089 10.7168Z"
          style={{ fill: fillColor }}
        />
      </g>
      <defs>
        <clipPath id="clip0_929_6975">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
